import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useLocation } from '../../hooks/useLocation.js';
import { OfficesAtmsMapLayout } from './OfficesAtmsMapLayout.js';
import { getOfficePoint, renderOfficeCard } from './renderOfficeCard.js';
import { getRemoteWorkplacePoint, renderRemoteWorkplaceCard } from './renderRemoteWorkplaceCard.js';
import { useOffices } from './useOffices.js';
const INITIAL_FILTRATION_STATE = {
    workingSaturday: false,
    premiumService: false,
    privateBanking: false,
    remoteWorkplace: false,
    serviceDisabledPeople: false,
    sellingCoins: false,
    buyingCoins: false,
    bullionOperations: false,
    preciousMetalsOperations: false,
    transferringDataToBiometricSystem: false,
};
const FILTRATION_PREDICATES = {
    workingSaturday: (item) => Boolean('workSchedule' in item && item.workSchedule?.workingSaturday),
    premiumService: (item) => Boolean('premiumService' in item && item.premiumService),
    privateBanking: (item) => Boolean('privateBanking' in item && item.privateBanking),
    remoteWorkplace: (item) => Boolean('workScheduleDescription' in item),
    serviceDisabledPeople: (item) => Boolean('serviceDisabledPeople' in item && item.serviceDisabledPeople),
    sellingCoins: (item) => Boolean('sellingCoins' in item && item.sellingCoins),
    buyingCoins: (item) => Boolean('buyingCoins' in item && item.buyingCoins),
    bullionOperations: (item) => Boolean('bullionOperations' in item && item.bullionOperations),
    preciousMetalsOperations: (item) => Boolean('preciousMetalsOperations' in item && item.preciousMetalsOperations),
    transferringDataToBiometricSystem: (item) => Boolean('transferringDataToBiometricSystem' in item && item.transferringDataToBiometricSystem),
};
export const OfficesMap = JSX(({ className }) => {
    const [currentLocation] = useLocation();
    const regionCode = currentLocation?.code ?? '000';
    const { data, isLoad } = useOffices(regionCode);
    return (_jsx(OfficesAtmsMapLayout, { className: className, filterItems: filterItems, data: data?.branches, isLoad: isLoad, remoteWorkplaces: data?.remoteWorkplaces, initFilterState: INITIAL_FILTRATION_STATE, renderCard: renderOfficeCard, renderRemoteWorkplaceCard: renderRemoteWorkplaceCard, getBalloon: getOfficePoint, getBalloonRemoteWorkplaces: getRemoteWorkplacePoint, title: `Офисы филиала ${currentLocation?.name}` }));
});
const filterItems = (data, filtrationState) => {
    const truthyFilters = Object.keys(filtrationState).filter((key) => filtrationState[key]);
    return data.filter((item) => truthyFilters.every((_) => FILTRATION_PREDICATES[_](item)));
};
//# sourceMappingURL=OfficesMap.js.map